<template>
  <div class="header bigger-font">
    <b-row>
      <b-col cols="6" lg="2">
        <a @click="hideMenuAfterClick"><router-link class="text-black" :to="{ name: 'Home'}"><img class="logo" src="../../public/logo.png" width="50px">Deploy10</router-link></a>
      </b-col>
      <b-col cols="0" lg="8" class="d-none d-sm-none d-md-none d-lg-block">
        <div class="margin-top">
          <div v-if="user && user.email" class="center-align">
            <router-link class="text-black margin" :to="{ name: 'Home'}">Home</router-link>
            <router-link class="text-black margin" :to="{ name: 'Pricing'}">Pricing</router-link>
            <router-link class="text-black margin" :to="{ name: 'Deployments'}">My deployments</router-link>
          </div>
          <div v-else class="center-align">
            <router-link class="text-black margin" :to="{ name: 'Home'}">Home</router-link>
            <router-link class="text-black margin" :to="{ name: 'Pricing'}">Pricing</router-link>
          </div>
        </div>
      </b-col>
      <b-col cols="2" lg="0" class="d-md-block d-lg-none d-xl-none">
      </b-col>
      <b-col cols="0" lg="2" class="d-none d-sm-none d-md-none d-lg-block">
        <div v-if="user && user.email" class="margin-top right-align">
          <router-link  class="text-black margin" :to="{ name: 'Account'}">Account</router-link>
          <a class="text-black"><fa-icon icon="sign-out-alt" @click="signOut" title="Sign out" /></a>
        </div>
        <div v-else class="margin-top right-align">
          <router-link class="text-black margin" :to="{ name: 'LogIn'}">Log In</router-link>
          <router-link class="text-black margin" :to="{ name: 'SignUp'}">Sign Up</router-link>
        </div>
      </b-col>
      <b-col cols="4" lg="0" class="d-md-block d-lg-none d-xl-none">
        <div v-if="!mobileMenuDisplayed" class="right-align">
          <a class="text-black"><fa-icon class="fa-3x" icon="bars" @click="displayMenu" title="Menu" /></a>
        </div>
        <div v-else class="right-align">
          <a class="text-black"><fa-icon class="fa-3x" icon="times" @click="displayMenu" title="Menu" /></a>
        </div>
      </b-col>
    </b-row>
    <div v-show="mobileMenuDisplayed">
      <b-row cols="3" cols-sm="3" cols-md="3" cols-lg="3" cols-xl="3">
        <b-col>
        </b-col>
        <b-col>
          <div>
            <div class="center-align bigger-font-x2">
              <a @click="hideMenuAfterClick"><router-link class="text-black margin" :to="{ name: 'Home'}">Home</router-link></a>
              <br>
              <br>
              <a @click="hideMenuAfterClick"><router-link class="text-black margin" :to="{ name: 'Pricing'}">Pricing</router-link></a>
              <br>
              <br>
              <span v-if="user && user.id">
                <a @click="hideMenuAfterClick"><router-link class="text-black margin" :to="{ name: 'Deployments'}">My deployments</router-link></a>
                <br>
                <br>
              </span>
              <div v-if="user && user.email">
                <a @click="hideMenuAfterClick"><router-link  class="text-black margin" :to="{ name: 'Account'}">Account</router-link></a>
                <br>
                <br>
                <a class="text-black"><fa-icon icon="sign-out-alt" @click="signOut" title="Sign out" /></a>
              </div>
              <div v-else>
                <div>
                  <a @click="hideMenuAfterClick"><router-link class="text-black margin" :to="{ name: 'LogIn'}">Log In</router-link></a>
                  <br>
                  <br>
                  <a @click="hideMenuAfterClick"><router-link class="text-black margin" :to="{ name: 'SignUp'}">Create an account</router-link></a>
                </div>
              </div>
            </div>
          </div>
        </b-col>
        <b-col>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>

import { onLogout } from '../vue-apollo';

  export default {
    name: 'Header',
    components: {  },
    data() {
      return {
        mobileMenuDisplayed: false
      }
    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      }
    },
    methods: {
      async signOut() {
        await onLogout.apply(this, [this.$apollo.provider.defaultClient])
        if (this.$router.currentRoute.name !== 'Home') this.$router.push({ name: 'Home' });
        this.$router.go(0); // refresh the current page
      },
      displayMenu() {
        if (this.mobileMenuDisplayed === false) {
          this.mobileMenuDisplayed = true
        } else {
          this.mobileMenuDisplayed = false
        }
      },
      hideMenuAfterClick() {
        this.mobileMenuDisplayed = false
      },
    }
  }
</script>

<style scoped>

</style>
